<div class="trial-editor" *ngIf="trial">

  <ng-container>
    <gen-trial-header [trial]="trial">
    </gen-trial-header>

    <div class="cohortHeader">
      <div class="cohortList">Cohort List</div>
    </div>

    <div *ngIf="trial.profile" [dragula]=listName [dragulaModel]="trial.profile.cohorts">
      <gen-cohort-container class="cohort-container-panel"
                            *ngFor="let cohort of trial.profile.cohorts"
                            [cohort]="cohort"
                            [enableCohortDragging]="isDraggable()"
                            (cloneMe)="cloneCohort($event)"
                            (deleteMe)="deleteCohort($event)"
                            (enableDraggable)="enableDraggable($event)"
      >
      </gen-cohort-container>
    </div>

  </ng-container>
  <div style="display: flex">
    <div *ngIf="noCohortsAndHasArms()" class="init-cohortlist-button" (click)="initializeCohortList()">Initialize Cohort List</div>
    <div class="add-cohort-button" (click)="addCohort()">Add Cohort</div>
  </div>

</div>
